import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Predicate, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { Browser, enableRipple, isNullOrUndefined } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, PageService, PdfExportService, SearchSettingsModel, SelectionSettingsModel, SortService, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';


// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { RuleModel, QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { SearchSubject } from 'src/app/shared/models/searchSubject.model';
setCurrencyCode('AUD');
import { projectData, sampleData } from 'src/app/components/grid/jobs-grid/jsontreegredidata';
import { CategoryService, ChartComponent, ColumnSeriesService, IPointEventArgs, LineSeriesService, StackingColumnSeriesService, ChartModule, TooltipService  } from '@syncfusion/ej2-angular-charts';

import { Chart, LineSeries, DateTime, Legend, Tooltip, ILoadedEventArgs, ChartTheme,Category, ColumnSeries, } from '@syncfusion/ej2-charts';
import { AccumulationChart, AccumulationChartComponent,ChartAllModule, IAccLoadedEventArgs, AccumulationTheme, AccumulationChartAllModule } from '@syncfusion/ej2-angular-charts';
// import { Browser } from '@syncfusion/ej2-base';
import { } from '@syncfusion/ej2-angular-charts';



@Component({
  selector: 'app-metric-chart-multi-series-staff-all-line',
  templateUrl: './metric-chart-multi-series-staff-all-line.component.html',
  styleUrls: ['./metric-chart-multi-series-staff-all-line.component.scss'],
  providers: [CategoryService, ColumnSeriesService, TooltipService]
})
export class MetricChartMultiSeriesStaffAllLineComponent implements OnInit {

       // setup as observable?
       @Input() item_id?: any; // impliments on changes.
       @Input() item_data? // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = 'side'; // side | abstract | full

         // chart 
       public primaryXAxis: Object;
       public primaryYAxis: Object;
       public title: string;
       public data: any[] = [];
       public dynamicSeries: any[] = [];
  marker: { visible: boolean; };
  
     
  public data_pie: Object[] = [
    { Country : "Argentina", Population : 505370, Radius : Browser.isDevice ? '110' : "100", text: 'Argentina'},
    { Country : "Belgium",    Population : 551500, Radius : Browser.isDevice ? '120' :"118.7", text: 'Belgium' },
    { Country : "Dominican Republic",  Population : 312685 , Radius : '137.5', text: Browser.isDevice ? 'Dominican <br> Republic' :  'Dominican Republic' },
    { Country : "Cuba", Population : 350000 , Radius : '124.6', text: 'Cuba'},
    { Country : "Egypt", Population : 301000 , Radius : "150.8", text: 'Egypt'},
    { Country : "Kazakhstan", Population : 300000, Radius : "155.5",text: 'Kazakhstan'},
    { Country : "Somalia",  Population : 357022, Radius : "160.6", text: 'Somalia'}
];
@ViewChild('pie')
public pie: AccumulationChartComponent | AccumulationChart;


  // Additional chart properties
  public legendSettings: Object = { visible: true };
  public tooltip: Object = { enable: true };
  public title_pie: string = 'User Log Types';
  public enableSmartLabels: boolean = true;
  public enableAnimation: boolean = true;
  public dataLabel: Object = {
    visible: true,
    position: 'Inside',
    name: 'text'
  };
  public radius: string = '100%';



//Initializing Legend
// public legendSettings: Object = {
//     visible: true,
//     reverse: true
// };
// //Initializing Datalabel
// public dataLabel: Object = {
//     visible: true, position: Browser.isDevice ? 'Inside' : 'Outside',
//     name: 'text',
//     connectorStyle: { length: '20px', type:'Curve' },
//     font: {
//         fontWeight: '600'
//     },
//     enableRotation: true,
// };
  // custom code start
public load(args: IAccLoadedEventArgs): void {
    let selectedTheme: string = location.hash.split('/')[1];
    selectedTheme = selectedTheme ? selectedTheme : 'Fluent2';
    args.accumulation.theme = <AccumulationTheme>(selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark").replace(/contrast/i, 'Contrast').replace(/-highContrast/i, 'HighContrast');
}
  // custom code end
// public radius: string = 'Radius';
// public enableAnimation: boolean = true;
// public enableSmartLabels: boolean = true;
// public tooltip: Object = {
//     enable: true,
//     header: '',
//     format: '<b>${point.x}</b><br>Area in square km: <b>${point.y}</b><br>Population density per square km: <b>${point.tooltip}</b>',
//     name: 'Radius'
// };
// public title_pie: string = 'Pie with different Radius';
  




      
    constructor(
      private http: HttpClient, private router: Router,
      private route: ActivatedRoute, private _demoService: DemoService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private modalService: BsModalService,
     public toastr: HotToastService,
     vcr: ViewContainerRef,
     private _mysqlService: MysqlService,
  
    ) {}

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.item_data && this.item_data) {
      this.setupChartData();
    }
  }




  private setupChartData(): void {


    // Transform item_data to extract log types and their counts
    this.data_pie = this.item_data
      .flatMap(user =>
        user.user_logs_array.map(log => ({
          Country: log.log_type_name,  // The log type name
          Population: log.count,       // The count for each log type
          Radius: Browser.isDevice ? '110' : '100',
          text: log.log_type_name,     // The label for display
        }))
      
      );
  
  




 
    }
  




}
